// extracted by mini-css-extract-plugin
export default {"rootCard":"CoacheeNotes_rootCard__e-7AK"};